export default __webpack_public_path__ + "static/media/Cover4.35efb217.png";